import './vendor';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
require('../../node_modules/@cmyee/pushy/js/pushy.js')
// require('../../node_modules/video.js/dist/video.js')
// require('../../node_modules/videojs-contrib-hls/dist/videojs-contrib-hls.js')

import videojs from 'video.js';
// require('../../node_modules/videojs-contrib-hls/dist/videojs-contrib-hls.js')
import Swiper, { Pagination, Autoplay, Navigation, EffectFade, Controller, Mousewheel, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade,  Pagination, Controller, Mousewheel, Scrollbar ]);




/*Magnific модальное окно */
if(document.querySelector(".popup-with-form")) {
	$('.popup-with-form').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#name',
		mainClass: 'mfp-fade',
		callbacks: {
			beforeOpen: function() {
				if($(window).width() < 700) {
					this.st.focus = false;
				} else {
					this.st.focus = '#name';
				}
			}
		}
	});
}

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});


/*Magnific галерея*/
if(document.querySelector(".popup-gallery")) {
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Загрузка изображения #%curr%...',
		mainClass: 'mfp-fade mfp-img-mobile',
		gallery: {
			enabled: true,
			tCounter: '%curr% из %total%',
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
			titleSrc: function(item) {
				return '';
			}
		}
	});
}


const slider = new Swiper('.slider', { 
	loop: false,
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 10,
	speed: 1000,
	rewind: true,
	navigation: {
		prevEl: '#slider-prev',
		nextEl: '#slider-next',
	},
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
	},
        breakpoints: {
            1920: {
                slidesPerView: 1,
            },
            1028: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 1,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});

const servSlider = new Swiper('.serv-slider', { 
	loop: true,
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 24,
	speed: 1000,
	navigation: {
		prevEl: '#slider-serv-prev',
		nextEl: '#slider-serv-next',
	},
        breakpoints: {
            1920: {
                slidesPerView: 3,
            },
	    992: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});

const clientsSlider = new Swiper('.clients-slider ', { 
	loop: true,
        slidesPerView: 5,
        paginationClickable: true,
        spaceBetween: 24,
	speed: 1000,
	navigation: {
		prevEl: '#slider-clients-prev',
		nextEl: '#slider-clients-next',
	},
	pagination: {
		el: '.swiper-pagination',
	},
        breakpoints: {
            1920: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 4,
            },
            576: {
                slidesPerView: 4,
            },
	    320: {
                slidesPerView: 2,
		spaceBetween: 12,
            }
        }
});

const reviewsSlider = new Swiper('.reviews-slider ', { 
	loop: true,
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 24,
	speed: 1000,
	navigation: {
		prevEl: '#slider-reviews-prev',
		nextEl: '#slider-reviews-next',
	},
	pagination: {
		el: '.swiper-pagination',
	},
        breakpoints: {
            1920: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1
            },
            576: {
                slidesPerView: 1,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});




const teamSlider = new Swiper('.team-slider', { 
	loop: true,
        slidesPerView: 4,
        paginationClickable: true,
        spaceBetween: 24,
	speed: 1000,
	navigation: {
		prevEl: '#slider-team-prev',
		nextEl: '#slider-team-next',
	},
        breakpoints: {
            1920: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});

const sliderContent = new Swiper('.content-slider', { 
	loop: false,
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 24,
	speed: 1000,
	rewind: true,
	navigation: {
		prevEl: '#slider-content-prev',
		nextEl: '#slider-content-next',
	},
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
	},
        breakpoints: {
            1920: {
                slidesPerView: 2,
            },
            1028: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 1,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});

$(".accordeon dd").hide().prev().click(function() {
	$(this).parents(".accordeon").find("dd").not(this).slideUp().prev().removeClass("active");
	$(this).next().not(":visible").slideDown().prev().addClass("active");
});

$(".tabblock .tabblock__tabitem  ").not(":first").hide();
$(".tabblock .tabblock__tab").click(function() {
	$(".tabblock .tabblock__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".tabblock__tabitem").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");

$(".tabblock__tabmobile ").click(function() {
	$(this).toggleClass("is-active");
	$(this).parents(".tabblock__tabitem ").find(".tabblock__tabwrapper ").slideToggle();
})

if(document.querySelector("#video-js")) {
	let video = videojs('#video-js', {
		controls: false,
		autoplay: true,
		loop: true,
		height: '100%',
		poster: '/video/cover.jpg',
			html5: {
			nativeAudioTracks: false,
			nativeVideoTracks: false,
			nativeTextTracks: false,
			hls: {
			overrideNative: true,
			},
		},
	});

	video.src({
		type: 'application/x-mpegURL',
		src: 'video/video.m3u8',
		withCredentials: true,
	});


	let srcvideo =  $('#video-js').find('source').attr('src')

}
window.videojs = videojs;